import type { Ref, TextareaHTMLAttributes } from 'react';
import { useFormFieldContext } from '@/ui';
import styles from './Admin.module.css';

/**
 * COK SATIRLI METIN ALANI — feature ICINDE.
 *
 * `src/ui` altina konmadi: ortak ilkel kumesi paylasilan bir yuzey ve su an
 * bu alani isteyen TEK ekran duyuru bestecisi. Ortak kumeye bir bilesen
 * eklemek, onu her ekranin sozlesmesi haline getirir; ihtiyac ikinci bir
 * yerde dogdugunda tasinmasi kolay, erken tasinmisi geri almak zordur.
 *
 * `useFormFieldContext` KULLANILIYOR: FormField, id ve aria baglarini
 * context'ten veriyor (bkz. src/ui/Input.tsx). Ciplak bir <textarea>
 * yazilsaydi etiketle kontrol arasindaki bag kopardi — etikete tiklamak
 * odaklamaz, ekran okuyucu alani "etiketsiz" okur.
 */
export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  ref?: Ref<HTMLTextAreaElement>;
};

export function Textarea({
  id,
  className,
  'aria-describedby': describedBy,
  'aria-invalid': ariaInvalid,
  ...rest
}: TextareaProps) {
  const field = useFormFieldContext();
  return (
    <textarea
      id={id ?? field?.controlId}
      aria-describedby={describedBy ?? field?.describedBy}
      aria-invalid={ariaInvalid ?? (field?.invalid ? true : undefined)}
      className={[styles.textarea, className].filter(Boolean).join(' ')}
      {...rest}
    />
  );
}
